<template>
  <div>
    <div class="header">
      <img
        class="header-return"
        @click="onClickReturn"
        src="@/assets/icons/icon_return.png"
      />
      {{ title }}
      <img
        class="header-share"
        v-if="showShare"
        @click="onClickShare"
        src="@/assets/icons/icon_share.png"
      />
    </div>
    <!-- share popup -->
    <van-popup
      class="share-popup"
      v-model="showSharePopup"
      position="bottom"
      round
    >
      <div class="top"></div>
      <div class="content">
        <div class="title">{{ $t("Application.Share") }}</div>
        <div class="copy">
          <div class="copy-left">{{ shareUrl }}</div>
          <div class="copy-right" @click="onClickCopy">
            <img src="@/assets/icons/icon_copy.png" />
            {{ $t("Application.Copy") }}
          </div>
        </div>
        <div class="divider"></div>
        <div class="share-mode">
          <div class="mode-item">
            <img src="@/assets/icons/icon_twitter.png" />
            {{ $t("Application.Twitter") }}
          </div>
          <div class="mode-item">
            <img src="@/assets/icons/icon_instagram.png" />
            {{ $t("Application.Instagram") }}
          </div>
          <div class="mode-item">
            <img src="@/assets/icons/icon_facebook.png" />
            {{ $t("Application.Facebook") }}
          </div>
          <div class="mode-item">
            <img src="@/assets/icons/icon_whatsapp.png" />
            {{ $t("Application.Whatsapp") }}
          </div>
          <div class="mode-item">
            <img src="@/assets/icons/icon_snapchat.png" />
            {{ $t("Application.Snapchat") }}
          </div>
          <div class="mode-item">
            <img src="@/assets/icons/icon_email.png" />
            {{ $t("Application.Email") }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "FixedTop",
  props: {
    title: {
      type: String,
      default: ""
    },
    showShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSharePopup: false,
      shareUrl:
        "Https://www.unicoreus.com/cartridgeinfo/batchid=strawberry000325"
    };
  },
  created() {},
  mounted() {},
  watch: {},
  //格式化属性
  filters: {},
  computed: {},
  methods: {
    onClickReturn() {
      this.$router.go(-1);
    },
    onClickShare() {
      this.showSharePopup = true;
    },
    onClickCopy() {
      this.$copyText(this.shareUrl)
        .then(() => {
          this.$toast({
            type: "success",
            message: this.$t("Application.CopySuccess"),
            forbidClick: true,
            duration: 1000,
            position: "bottom"
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  height: 50px;
  background: #f6f6f6;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  top: 0;
  z-index: 999;
  font-size: 20px;
  font-weight: bold;
  color: #222222;
  border-bottom: 1px solid #dddddd;

  .header-return {
    position: absolute;
    left: 16px;
    width: 20px;
    height: 20px;
  }

  .header-share {
    position: absolute;
    right: 16px;
    width: 20px;
    height: 20px;
  }
}
</style>
